import { useCollection, useDocument } from "../../hooks/useFirestore"
import { createManagedMutations } from "../../hooks/useManagedMutations"
import { useCurrentSchoolYear } from "../schoolYear/useSchoolYear"
import { collectionName } from "./attendanceEventMeta"
import { AttendanceEvent } from "./AttendanceEventType"

export function useAttendanceEvents({
   young_id,
   optionWhereNotJustified,
}: {
   young_id?: string
   optionWhereNotJustified?: boolean
}) {
   const { data: currentSchoolYear } = useCurrentSchoolYear()
   const schoolyear_id = currentSchoolYear?.id

   const query = useCollection<AttendanceEvent>({
      collectionName,
      enabled: !!young_id && !!schoolyear_id,
      suffixKey: ["statistics", young_id, String(optionWhereNotJustified)],
      transform: (queryy) => {
         const query = queryy.where("[school_year_id+young_id]").equals([schoolyear_id!, young_id!])

         if (!optionWhereNotJustified) {
            return query
         } else {
            return query.and((doc: AttendanceEvent) => {
               return doc.justified === false
            })
         }
      },
   })

   if (!young_id || !schoolyear_id) {
      return {
         ...query,
         isLoading: true,
      }
   }

   return query
}

export function useAttendanceEvent({ id }: { id: string }) {
   return useDocument<AttendanceEvent>(collectionName, id)
}


export function useAttendanceEventsForAll({ whereNotJustified }: { whereNotJustified?: boolean }) {
   const { data: currentSchoolYear } = useCurrentSchoolYear()
   const schoolyear_id = currentSchoolYear?.id

   return useCollection<AttendanceEvent>({
      enabled: !!schoolyear_id,
      collectionName,
      suffixKey: ["statistics"],
      transform: (queryy) => {
         const query = queryy
            .where("school_year_id").equals(schoolyear_id!)
            .and((doc: AttendanceEvent) => doc.type !== "external")

         if (!whereNotJustified) {
            return query
         } else {
            return query.filter((doc: AttendanceEvent) => {
               return doc.justified === false
            })
         }
      },
   })
}

export const {
   useCreateManagedDocument: useCreateAttendanceEvent,
   useUpdateManagedDocument: useUpdateAttendanceEvent,
   useDeleteManagedDocument: useDeleteAttendanceEvent,
} = createManagedMutations<AttendanceEvent>(collectionName)
